var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Typography, Button, Card, CardActions, CardBody, CardTitle, useBreakpoint, } from '@one-thd/sui-atomic-components';
import { analyticsClick } from '../../../../utils/analytics';
import { scrollToAnchorPosition } from '../../anchor-scroll';
var HeadingTitle = function (props) {
    var text = props.text, num = props.num, isMobile = props.isMobile;
    return (React.createElement("div", { className: "md:sui-flex md:sui-items-center" },
        React.createElement(Typography, { variant: isMobile ? 'h5' : 'h3' },
            text,
            " ",
            typeof num !== 'undefined' && "(".concat(num, ")"))));
};
var HeadingLink = function (props) {
    var url = props.url, title = props.title;
    var isGreaterThanSM = useBreakpoint('sm').greater;
    var isLesserThanMD = useBreakpoint('md').lesser;
    var isInRange = isGreaterThanSM && isLesserThanMD;
    var content = isInRange ? 'FAQs' : "".concat(title, " FAQs");
    return (React.createElement("button", { type: "button", className: "sui-cursor-pointer sui-underline", onClick: function () {
            scrollToAnchorPosition({ id: url });
            analyticsClick("rewards hub: ".concat(title && title.toLowerCase(), "card: faq link"));
        }, "data-testid": "faq-link" }, content));
};
var FooterLink = function (props) {
    var text = props.text, url = props.url, callback = props.callback;
    return (React.createElement(Button, { variant: "secondary", href: url, onClick: callback, fullWidth: true },
        "Show All ",
        text));
};
var RewardsContainerMW = function (_a) {
    var title = _a.title, faqTitle = _a.faqTitle, children = _a.children, itemAmount = _a.itemAmount, headerUrl = _a.headerUrl, footerUrl = _a.footerUrl, footerCallback = _a.footerCallback, FooterButton = _a.FooterButton, noHeightLimit = _a.noHeightLimit, _b = _a.minHeight, minHeight = _b === void 0 ? '330px' : _b, dataTestID = _a.dataTestID;
    var minHeightClass = noHeightLimit ? '' : "sui-min-h-[".concat(minHeight, "]");
    return (React.createElement(Card, { disablePadding: true, PaperProps: { variant: 'shadow' }, className: "".concat(minHeightClass, " sui-py-6 sui-flex"), CardContentProps: { grow: true, initialSize: 'full', density: 'loose' }, "data-testid": dataTestID },
        React.createElement(CardTitle, { action: !!headerUrl && React.createElement(HeadingLink, { url: headerUrl, title: faqTitle }), header: React.createElement(HeadingTitle, { text: title, num: itemAmount, isMobile: true }), actionPosition: "center", disableActionSpacing: true }),
        React.createElement(CardBody, null,
            React.createElement("div", { className: "sui-h-2" }),
            children),
        (footerUrl || footerCallback || FooterButton) && (React.createElement(CardActions, null,
            React.createElement("div", { className: "sui-w-full sm:sui-mt-4" },
                !!FooterButton && React.createElement(FooterButton, { isMobile: true }),
                !FooterButton && (React.createElement(FooterLink, { text: title, url: footerUrl, callback: footerCallback })))))));
};
var RewardsContainerDTW = function (_a) {
    var title = _a.title, faqTitle = _a.faqTitle, children = _a.children, itemAmount = _a.itemAmount, headerUrl = _a.headerUrl, footerUrl = _a.footerUrl, footerCallback = _a.footerCallback, FooterButton = _a.FooterButton, noHeightLimit = _a.noHeightLimit, _b = _a.minHeight, minHeight = _b === void 0 ? '360px' : _b, dataTestID = _a.dataTestID;
    var minHeightClass = noHeightLimit ? '' : "sui-min-h-[".concat(minHeight, "]");
    return (React.createElement(Card, { CardContentProps: { grow: true, initialSize: 'full', density: 'loose' }, className: "".concat(minHeightClass, " sui-flex"), "data-testid": dataTestID },
        React.createElement(CardTitle, { action: !!headerUrl && React.createElement(HeadingLink, { url: headerUrl, title: faqTitle }), header: React.createElement(HeadingTitle, { text: title, num: itemAmount, isMobile: true }), actionPosition: "center", disableActionSpacing: true }),
        React.createElement(CardBody, null, children),
        (footerUrl || footerCallback || FooterButton) && (React.createElement(CardActions, null,
            !!FooterButton && React.createElement(FooterButton, null),
            !FooterButton && (React.createElement(FooterLink, { text: title, url: footerUrl, callback: footerCallback }))))));
};
export var RewardCardContainer = function (props) {
    var isMobile = props.isMobile;
    return isMobile ? (React.createElement(RewardsContainerMW, __assign({}, props))) : (React.createElement(RewardsContainerDTW, __assign({}, props)));
};
